// extracted by css-extract-rspack-plugin
export default {"cls1":"buttonStyles-cls1_tZr","cls2":"buttonStyles-cls2_hVp buttonStyles-cls1_tZr"};